import { Component, createMemo, createSignal, Match, Show, Switch, useContext } from 'solid-js'
import type { Engine } from '../../lib/core/engine/Engine.type'
import getPlayerGraphNode from '../../lib/core/engine/PlayerGraphNode/getPlayerGraphNode'
import getPerTurnIncomeFromPlayerEnts from '../../lib/core/entity/getPerTurnIncomeFromPlayerEnts'
import playerDisplayName from '../../lib/core/player/playerDisplayName'
import { PlayerGameStatus } from '../../lib/core/player/PlayerGameStatus'
import type { PlayerId } from '../../lib/core/player/PlayerId'
import { useAuthPlayerIdSignal } from '../../rx/signal/useAuthPlayerIdSignal'
import { PlayerTurnStatus } from '../../lib/core/player/PlayerTurnStatus'
import type { Nullable } from '../../typescript'
import PlayerGameStatusBadge from '../Badge/PlayerGameStatusBadge'
import EngineContext from '../EngineContext'
import PerTurnIncome from './PerTurnIncome'
import PlayerMoneyCornerWidget from './PlayerMoneyCornerWidget'

const OtherTurnPlayerCornerWidget: Component = () => {
  const engine: Engine = useContext(EngineContext)
  const [getAuthPlayerId] = useAuthPlayerIdSignal(engine)

  // "other turn player"
  // the player whose turn it is
  // when it is not your turn
  const getOtherTurnPlayerId = createMemo<Nullable<PlayerId>>((): Nullable<PlayerId> => {
    const authPlayerId = getAuthPlayerId()
    const { turnPlayerId } = engine.state
    if (authPlayerId === turnPlayerId) {
      return null
    }
    return turnPlayerId
  })

  return (
    <Show when={getOtherTurnPlayerId()} keyed children={(otherTurnPlayerId) => {

      const player = getPlayerGraphNode(engine, otherTurnPlayerId)

      const perTurnIncome = createMemo<number>(() => {
        return getPerTurnIncomeFromPlayerEnts(player.ents())
      })

      // const [isBusy, setIsBusy] = createSignal<boolean>(false)
      const [isMoneyWidgetOpen, setIsMoneyWidgetOpen] = createSignal<boolean>(false)

      return <>
        <div class="cw cw-player2 cw-sm-tl">
          <div class="text-break">{playerDisplayName(player())}</div>
          <div class="d-flex justify-content-between">
            <Show when={player().game_status !== PlayerGameStatus.Active}>
              <PlayerGameStatusBadge player={player()} />
            </Show>
            <Switch>
              <Match when={player().turn_status === PlayerTurnStatus.Done}>
                <span class="fs-6">Done</span>
              </Match>
              <Match when={player().turn_status === PlayerTurnStatus.Pending}>
                <span class="fs-6">Pending</span>
              </Match>
              <Match when={player().turn_status === PlayerTurnStatus.Playing}>
                <span class="fs-6 ellipsis-animated">Playing</span>
              </Match>
              <Match when={player().turn_status === PlayerTurnStatus.Waiting}>
                <span class="fs-6">Waiting</span>
              </Match>
            </Switch>
          </div>
          <PerTurnIncome value={perTurnIncome()} player={player()} onClick={() => {
            setIsMoneyWidgetOpen(!isMoneyWidgetOpen())
          }} />
        </div>
        <PlayerMoneyCornerWidget
          class="player2 cw-sm-bl"
          when={isMoneyWidgetOpen()}
          setOpen={setIsMoneyWidgetOpen}
          player={player}
        />
      </>
    }} />
  )
}

export default OtherTurnPlayerCornerWidget
